module.exports = __webpack_public_path__ + "static/media/2.f567d35c.JPG";